// extracted by mini-css-extract-plugin
export default {"container":"signOutButton_container__vGyyc","icon":"signOutButton_icon__ui3oU","text":"signOutButton_text__O7stW"};